import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { List, Image } from "semantic-ui-react";
import { CartData, orderBy } from "../../../types/siteTypes";
import styles from "./OrderItem.module.scss";
import { formatEur } from "../../../utils/patternPricing";
import { formatPatternSizeLabel } from "../../../utils/patternSize";

const OrderItem = ({ item, orderBy }: { item: CartData; orderBy?: orderBy }) => {
  const selectedSize =
    item.selectedSize || (item.sizes?.length === 1 ? item.sizes[0] : "");
  const displayedSize = selectedSize ? formatPatternSizeLabel(selectedSize) : "-";

  return (
    <List.Item className={styles.self}>
      <Image avatar src={item.photo ? item.photo.url : "/photos/no-photo.jpg"} />
      <List.Content>
        <List.Header>
          <Link to={`/pattern/${item.id}`}>{item.name}</Link>
          <span className={styles.priceBlock}>
            {item.showPromotionInfo &&
            item.originalPrice !== null &&
            item.originalPrice !== undefined ? (
              <>
                <span className={styles.priceRow}>
                  <span className={styles.oldPrice}>{formatEur(item.originalPrice)}</span>
                  <b className={styles.price}>{formatEur(item.price)}</b>
                </span>
                {item.showOmnibusInfo &&
                  item.omnibusLowestPrice !== null &&
                  item.omnibusLowestPrice !== undefined && (
                    <span className={styles.omnibusLine}>
                      <FormattedMessage
                        id="cart.omnibusInfo"
                        defaultMessage="Lowest price in 30 days before discount: {price}"
                        values={{ price: formatEur(item.omnibusLowestPrice) }}
                      />
                    </span>
                  )}
              </>
            ) : (
              <>
                <b className={styles.price}>{formatEur(item.price)}</b>
                {item.showOmnibusInfo &&
                  item.omnibusLowestPrice !== null &&
                  item.omnibusLowestPrice !== undefined && (
                    <span className={styles.omnibusLine}>
                      <FormattedMessage
                        id="cart.omnibusInfo"
                        defaultMessage="Lowest price in 30 days before discount: {price}"
                        values={{ price: formatEur(item.omnibusLowestPrice) }}
                      />
                    </span>
                  )}
              </>
            )}
          </span>
        </List.Header>
        <List.Description>
          <FormattedMessage id="placeOrder.by" defaultMessage="By" />: <Link to={`/seller/${item.profileHandle || item.creatorId?._id}`}>
            {item.profileHandle || item.creatorId?.name || <FormattedMessage id="site.unknownSeller" defaultMessage="Unknown" />}
          </Link>
        </List.Description>
        <List.Description className={styles.sizeLine}>
          <FormattedMessage id="cart.tableTitle.size" defaultMessage="Size" />: {displayedSize}
        </List.Description>
      </List.Content>
    </List.Item>
  );
};

export default OrderItem;
